import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";

const wrapHandler = (handler) => (e) => handler(e.target.value);

const TableauVizPicker = ({
  selectedViewPath,
  selectedWorkbook,
  workbooks,
  views,
  onWorkbookChange,
  onViewChange,
  workbookLabel = "Workbook",
}) => {
  const wbOptions = workbooks.map((wb) => (
    <option value={wb.path} key={wb.id}>
      {wb.name}
    </option>
  ));
  const viewOptions = views.map((v) => (
    <option value={v.viewPath} key={v.id}>
      {v.name}
    </option>
  ));

  return (
    <div className="vizPicker">
      <Form>
        <FormGroup>
          <ControlLabel>{workbookLabel}:</ControlLabel>
          <FormControl
            componentClass="select"
            value={selectedWorkbook}
            placeholder="select"
            onChange={wrapHandler(onWorkbookChange)}
          >
            {wbOptions}
          </FormControl>
        </FormGroup>
        <FormGroup>
          <ControlLabel>View: </ControlLabel>
          <FormControl
            value={selectedViewPath}
            componentClass="select"
            placeholder="select"
            onChange={wrapHandler(onViewChange)}
          >
            {viewOptions}
          </FormControl>
        </FormGroup>
      </Form>
    </div>
  );
};

TableauVizPicker.propTypes = {
  selectedViewPath: PropTypes.string,
  selectedWorkbook: PropTypes.string,
  workbooks: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      path: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  views: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      viewPath: PropTypes.string,
    })
  ),
  onWorkbookChange: PropTypes.func,
  onViewChange: PropTypes.func,
  workbookLabel: PropTypes.string,
};

export default TableauVizPicker;
